import React from 'react'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
  StackProps,
  Text,
  VStack
} from '@chakra-ui/react'
import Link from 'next/link'
import HeadingTag from '@components/heading-tag'

export interface Crumb {
  label: string
  href?: string
}

interface FooterInfoLayoutPropsType {
  title: string
  children: React.ReactNode
  vstack?: StackProps
  breadcrumbs?: Crumb[]
}

const FooterInfoLayout: React.FC<FooterInfoLayoutPropsType> = ({
  title,
  children,
  vstack,
  breadcrumbs
}) => {
  return (
    <Container maxW={'1350px'} my={28}>
      <VStack spacing={8} {...vstack}>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumb
            w={'100%'}
            alignSelf={'stretch'}
            spacing={'8px'}
            fontSize={'sm'}
            color={'gray.500'}
            separator={<Text color={'gray.300'}>/</Text>}
          >
            {breadcrumbs.map((c, i) => {
              const isLast = i === breadcrumbs.length - 1
              return (
                <BreadcrumbItem key={i} isCurrentPage={isLast}>
                  {c.href && !isLast ? (
                    <BreadcrumbLink
                      as={Link}
                      href={c.href}
                      _hover={{ color: '#DE4800', textDecoration: 'none' }}
                    >
                      {c.label}
                    </BreadcrumbLink>
                  ) : (
                    <Text color={'gray.700'} fontWeight={500}>
                      {c.label}
                    </Text>
                  )}
                </BreadcrumbItem>
              )
            })}
          </Breadcrumb>
        )}
        <HeadingTag>{title}</HeadingTag>
        {children}
      </VStack>
    </Container>
  )
}

export default FooterInfoLayout
